export default __webpack_public_path__ + "static/media/continue.b1e0e9c0.svg";